<template>
  <svg width="100%" height="100%" viewBox="0 0 42 42">
    <circle
      class="donut-hole"
      cx="21"
      cy="21"
      r="15.91549430918954"
      fill="transparent"
    ></circle>
    <circle
      class="donut-ring"
      cx="21"
      cy="21"
      r="15.91549430918954"
      fill="transparent"
      stroke="#E2E2E2"
      stroke-width="6"
    ></circle>

    <circle
      class="donut-segment"
      cx="21"
      cy="21"
      r="15.91549430918954"
      fill="transparent"
      stroke="#ABABAB"
      stroke-linecap="round"
      stroke-width="6"
      :stroke-dasharray="`${percent2} ${100 - percent2}`"
      stroke-dashoffset="25"
    ></circle>
    <circle
      v-if="seq !== 1"
      class="donut-segment"
      cx="21"
      cy="21"
      r="15.91549430918954"
      fill="transparent"
      stroke="#009860"
      stroke-linecap="round"
      stroke-width="6"
      :stroke-dasharray="`${percent1} ${100 - percent1}`"
      stroke-dashoffset="25"
    ></circle>
  </svg>
</template>

<script>
export default {
  name: "BarChart",
  props: {
    seq: {
      type: Number,
      required: true,
    },
    maxSeq: {
      type: Number,
      required: true,
    },
  },
  computed: {
    percent1() {
      return ((this.seq - 1) * 100) / this.maxSeq;
    },
    percent2() {
      return (this.seq * 100) / this.maxSeq;
    },
  },
};
</script>
